import { GetVisualViewportBottomInset } from "./BottomBarHelpers";

export class BottomBarViewportManager {
    private visualViewportRefreshTimeouts: number[] = [];
    private visualViewportBottomInset = 0;
    private frame: number | undefined;
    private disconnectListeners: (() => void) | undefined;

    connect(onUpdate: (force: boolean) => void): void {
        this.disconnect();
        const viewport = window.visualViewport;
        const changed = () => {
            if (this.frame !== undefined) return;
            this.frame = window.requestAnimationFrame(() => {
                this.frame = undefined;
                onUpdate(false);
            });
        };
        const refresh = () => this.scheduleRefresh(onUpdate);
        viewport?.addEventListener("resize", changed);
        viewport?.addEventListener("scroll", changed);
        window.addEventListener("focus", refresh);
        window.addEventListener("pageshow", refresh);
        document.addEventListener("visibilitychange", refresh);
        document.addEventListener("focusin", refresh);
        this.disconnectListeners = () => {
            viewport?.removeEventListener("resize", changed);
            viewport?.removeEventListener("scroll", changed);
            window.removeEventListener("focus", refresh);
            window.removeEventListener("pageshow", refresh);
            document.removeEventListener("visibilitychange", refresh);
            document.removeEventListener("focusin", refresh);
        };
    }

    disconnect(): void {
        this.disconnectListeners?.();
        this.disconnectListeners = undefined;
        if (this.frame !== undefined) window.cancelAnimationFrame(this.frame);
        this.frame = undefined;
        this.clearRefreshTimeouts();
    }

    get bottomInset(): number {
        return this.visualViewportBottomInset;
    }

    computeBottomInset(_forceUpdate: boolean, lastKnown: number): number {
        const current = GetVisualViewportBottomInset();

        if (Math.abs(current - lastKnown) < 1) {
            return lastKnown;
        }

        this.visualViewportBottomInset = current;
        return current;
    }

    scheduleRefresh(onUpdate: (force: boolean) => void): void {
        onUpdate(true);

        this.visualViewportRefreshTimeouts.forEach((id) =>
            window.clearTimeout(id)
        );
        this.visualViewportRefreshTimeouts = [80, 250, 600, 1000].map(
            (delay) => window.setTimeout(() => onUpdate(true), delay)
        );
    }

    clearRefreshTimeouts(): void {
        this.visualViewportRefreshTimeouts.forEach((id) =>
            window.clearTimeout(id)
        );
        this.visualViewportRefreshTimeouts = [];
    }
}
